import { create } from 'zustand';
import { hasRole } from '@/lib/auth/has-role';
import type { User } from '@/lib/types';

interface AuthState {
  user: User | null;
  // A viewer is "internal" (DigitalZone) when their token carries the `admin`
  // role (NPJB-403) — NOT off `tenantType`, so a DZ-tenant user not yet granted
  // `admin` is correctly treated as a tenant user. Derived once on setUser so any
  // component can read it without re-deriving.
  isInternal: boolean;
  setUser: (user: User) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isInternal: false,
  setUser: (user) => {
    set({ user, isInternal: hasRole(user, 'admin') });
  },
  clear: () => {
    set({ user: null, isInternal: false });
  },
}));
